export function Footer() {
  return (
    <footer className="border-t border-surface-600 mt-16">
      <div className="max-w-6xl mx-auto px-4 py-6 flex items-center justify-between text-xs text-neutral-500">
        <span>© {new Date().getFullYear()} battery.cafe</span>
        <span>Find replacements for any appliance</span>
      </div>
    </footer>
  );
}
